module.exports = __webpack_public_path__ + "static/media/Gregg-Van-Orden-Resume.a0f715ab.pdf";